export const environment = {
  production: true,
  //baseHrefLink : 'baseHrefLinkDev',
  hostLaravel: 'hostLaravelDev',
  //urlLaravel: 'https://apigm.rio.rj.gov.br/api/v1/',
  urlLaravel: '/api/v1/',
  urlImg: 'http://gm.rio.rj.gov.br/apps/api/foto/getFoto/',
  urlImgAPIMapaUserId: 'https://mapa.gm.rio/api/v1/foto-agente-por-id-front/',
  urlImgAPIMapa: 'https://mapa.gm.rio/api/v1/foto-agente-por-id/',
  urlIcone: 'assets/img/portrait/small/'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts